import { MetaModel } from "./metaModel";
class ResponseModel {
  constructor(success, meta, data) {
    this.success = success;
    this.meta = meta;
    this.data = data;
  }

  static fromJson(json) {
    if (json == null) {
      return null;
    }
    return new ResponseModel(
      json["success"],
      MetaModel.fromJson(json["meta"]),
      json["data"]
    );
  }

  toJson() {
    return {
      success: this.success,
      meta: this.meta.toJson(),
      data: this.data,
    };
  }
}

export { ResponseModel };
